// A "yyyy-mm-dd" string for a day `daysAgo` days before today, using LOCAL
// date components - not toISOString(), which converts to UTC first. For any
// timezone ahead of UTC (e.g. Uganda, UTC+3), building today's date via
// toISOString() would silently return yesterday's date whenever the page
// loads between local midnight and the UTC offset.
export function localIsoDate(daysAgo = 0) {
  const d = new Date();
  d.setDate(d.getDate() - daysAgo);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
